import React from 'react'

class IntroPage extends React.Component{
  constructor(props){
    super(props)
  }

  componentDidMount(){
  }
  render(){
    return(
      <div className="center-align">
        <img id="welcome" className="top-img" src="./assets/img/img11.jpg" />
        <div id="intro-div">
          <img className="roundImage" src='./assets/img/me.jpg' />  
            <h2 id="name-header"> Liron Shimrony </h2>
            <h4 id="title-header"> Technologist, Tech Enthusiast &amp; Engineer </h4>
          </div>
        </div>
      

    )
  }
}

export default IntroPage


// WEBPACK FOOTER //
// ./app/components/IntroPage.js